import styled from 'styled-components';

export const StyledBorder = styled.div`
  border-top: 1px solid #3A3B46
`;
